import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Underline icon — U with underline stroke. */
const UnderlineIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M15.334 15.501C15.61 15.5012 15.834 15.7249 15.834 16.001C15.8338 16.2769 15.6099 16.5008 15.334 16.501H4.66699C4.39096 16.501 4.16717 16.277 4.16699 16.001C4.16699 15.7248 4.39085 15.501 4.66699 15.501H15.334ZM5.5 9.33398V3.33398C5.5 3.05795 5.72401 2.83416 6 2.83398C6.27614 2.83398 6.5 3.05784 6.5 3.33398V9.33398C6.5 11.2669 8.06715 12.8338 10 12.834C11.933 12.834 13.5 11.267 13.5 9.33398V3.33398C13.5 3.05795 13.724 2.83416 14 2.83398C14.2761 2.83398 14.5 3.05784 14.5 3.33398V9.33398C14.5 11.8193 12.4853 13.834 10 13.834C7.51487 13.8338 5.5 11.8192 5.5 9.33398Z" fill="currentColor" />
  </svg>
);

export default UnderlineIcon;
